import { clearAuthState } from './tokenUtils';

class AccountStatusChecker {
  constructor() {
    this.checkInterval = null;
    this.isChecking = false;
  }

  startChecking() {
    if (this.isChecking) return;
    
    this.isChecking = true;
    // Check every 15 minutes
    this.checkInterval = setInterval(() => {
      this.checkAccountStatus();
    }, 900000);
  }

  stopChecking() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
    this.isChecking = false;
  }

  async checkAccountStatus() {
    const token = sessionStorage.getItem('authToken');
    const user = sessionStorage.getItem('user');
    
    if (!token || !user) {
      this.stopChecking();
      return;
    }

    try {
      const parsedUser = JSON.parse(user);
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://riskreport.almata.co.jp:3400/api'}/socket/status?userId=${parsedUser._id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 404) {
        // Account deleted
        this.handleAccountDeleted();
      } else if (response.status === 401) {
        // Token expired or invalid
        clearAuthState();
        this.redirectToLogin();
      }
    } catch (error) {
      console.error('Account status check failed:', error);
    }
  }

  handleAccountDeleted() {
    this.stopChecking();
    clearAuthState();
    
    // Show notification to user
    alert('Account deleted. You will be redirected to the login page.');
    
    this.redirectToLogin();
  }

  redirectToLogin() {
    window.location.href = '/login';
  }
}

export const accountStatusChecker = new AccountStatusChecker();